import { Injectable } from '@angular/core';
import {InstiHelpers } from '../../insti/instihelpers.module';
import { InstiService } from '../../insti/insti.service';
import { instiMenuItem } from '../../insti/instiMenuItem';


export interface BadgeItem {
  type: string;
  value: string;
}
export interface Saperator {
  name: string;
  type?: string;
}
export interface SubChildren {
  state: string;
  name: string;
  type?: string;
}
export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
  child?: SubChildren[];
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  saperator?: Saperator[];
  children?: ChildrenItems[];
  rules?:any; //::Pode ser uma string ou uma funcao de callback
  show?:boolean;
  disabled?:boolean;
}
const insti_service =InstiService;
const MENUITEMS = [
  {
    state: '',
    name: 'MENU',
    type: 'saperator',
    icon: 'av_timer' 
  },
  // {
  //   state: 'home',
  //   name: 'Home',
  //   type: 'link',
  //   icon: 'home',
  // },
  {
    state: 'gestao-condominio',
    name: 'Gestão Imóveis',
    type: 'sub',
    icon: 'home', 
    children:[
      {
        state: 'master-gestao-imoveis',
        name: 'Imóveis',
        type: 'link',
        icon: 'home',
      }, 
      {
        state: 'medicao-gestor',
        name: 'Medições',
        type: 'link',
        icon: 'home',
      },
      {
        state: 'medicao',
        name: 'Medição Residual',
        type: 'link',
        icon: 'home',
      },
      {
        state: 'nota-debito',
        name: 'Nota de débito',
        type: 'link',
        icon: 'home',
      },
      // {
      //   state: 'config-email',
      //   name: 'Configuração E-mail',
      //   type: 'link',
      //   icon: 'home',
      // },
      // {
      //   state: 'instrucoes-pgto',
      //   name: 'Instruções pagamento',
      //   type: 'link',
      //   icon: 'home',
      // },

      // {
      //   state: 'parametros',
      //   name: 'Parâmetros',
      //   type: 'link',
      //   icon: 'home',
      // }, 
    ]
  },
  // {
    // state: 'gestao-condominio',
    // name: 'LOCATÁRIO',
    // type: 'sub',
    // icon: 'home', 
    // children:[
      // {
      //   state: 'home-funcionario',
      //   name: 'Home',
      //   type: 'link',
      //   icon: 'home',
      // },
      // {
      //   state: 'home-terceiro',
      //   name: 'Home Terceiro',
      //   type: 'link',
      //   icon: 'home',
      // },
      // {
      //   state: 'master-locatario',
      //   name: 'Meus Imóveis',
      //   type: 'link',
      //   icon: 'home',
      // },
      // {
      //   state: 'meus-dados',
      //   name: 'Meus Dados',
      //   type: 'link',
      //   icon: 'home',
      // },
      // {
      //   state: 'filafunc',
      //   name: 'Minha fila',
      //   type: 'link',
      //   icon: 'home',
      // },
    // ]
  // },
 
  {
    state: '',
    name: 'CADASTROS',
    type: 'saperator',
    icon: 'av_timer'
  },
  {
    state: 'gestao-condominio-modelos',
    name: 'Acesso Cadastros',
    type: 'sub',
    icon: 'recent_actors',
    children: [ 
          {state: 'acesso-organizacional', name: 'Acesso Organizacional', type: 'link'},
          // {state: 'contrato-locacao', name: 'Contrato Locação', type: 'link'},
          // {state: 'tipo-anexo', name: 'Tipo de anexo', type: 'link'},
          // {state: 'anexo-docto', name: 'Tipo Anexo Documento', type: 'link'}
  ]},
  {
    state: 'gestao-condominio-modelos',
    name: 'Modelos',
    type: 'sub',
    icon: 'import_contacts',
    children: [ 
          {state: 'checklist', name: 'Checklist', type: 'link'},
          {state: 'contrato-locacao', name: 'Contrato Locação', type: 'link'},
          // {state: 'tipo-anexo', name: 'Tipo de anexo', type: 'link'},
          // {state: 'anexo-docto', name: 'Tipo Anexo Documento', type: 'link'}
  ]},
  {                                                         
    state: 'gestao-condominio-itens-checklist',
    name: 'Itens Checklist',                                  
    type: 'sub',
    icon: 'help_outline',
   children: [ 
          {state: 'pergunta', name: 'Itens Checklist', type: 'link'}
 ]},
  {
    state: 'gestao-condominio-endereco',
    name: 'Endereço',
    type: 'sub',
    icon: 'pin_drop',
   children: [ 
          {state: 'condominio', name: 'Condomínio', type: 'link'},
          {state: 'endereco', name: 'Endereço', type: 'link'}

 ]},
 {
  state: 'gestao-condominio-imoveis',
  name: 'Imóveis',
  type: 'sub',
  icon: 'store',
  children: [      
            // {state: 'agenda', name: 'Agenda', type: 'link'},
            {state: 'categoria-imovel', name: 'Categoria de Imóvel', type: 'link'},
            {state: 'tipo-casa', name: 'Tipo Imóvel', type: 'link'},
            {state: 'imovel', name: 'Imóveis', type: 'link'},
            // {state: 'ocupante', name: 'Ocupante', type: 'link'}
  ]},
  {
    state: 'gestao-condominio-pessoa',
    name: 'Pessoa',
    type: 'sub',
    icon: 'people',
    children: [  
              {state: 'pessoa-fisica', name: 'Pessoa Física', type: 'link'},
              {state: 'pessoa-juridica', name: 'Pessoa Jurídica', type: 'link'},          
              {state: 'funcionario', name: 'Funcionário', type: 'link'},
              {state: 'terceiro', name: 'Terceiro', type: 'link'},
              // {state: 'usuario', name: 'Usuário', type: 'link'},
              // {state: 'usuario', name: 'Usuário', type: 'link'},
              // {state: 'grupo-usuario', name: 'Grupo de Usuário', type: 'link'}
    ]
  },

  {
    state: 'gestao-condominio-servicos',
    name: 'Serviços',
    type: 'sub',
    icon: 'build',
    children: [ 
          // {state: 'resp-tecnico', name: 'Responsável Técnico', type: 'link'},
          {state: 'unidade-medida', name: 'Unidade de Medida', type: 'link'},
          {state: 'servico-consumo', name: 'Serviço Consumo', type: 'link'},
          // {state: 'preco-servico-vila', name: 'Preço por Serviço', type: 'link'},
         
    ]
  },  

  {
    state: 'gestao-condominio-multiempresa',
    name: 'Multi Empresa',
    type: 'sub',
    icon: 'supervised_user_circle',
    children: [ 
          {state: 'grupo', name: 'Grupo', type: 'link'},
          {state: 'empresa', name: 'Empresa', type: 'link'},
          {state: 'filial', name: 'Filial', type: 'link'},         
    ]
  },  
  {
    state: '',
    name: 'SEGURANÇA',
    type: 'saperator',
    icon: 'security'
  }, 
  {
    state: 'instiUser',
    name: 'Segurança',
    type: 'sub',
    icon: 'security',
    children: [ 
          {state: 'usuario', name: 'Usuário', type: 'link'},
          // {state: 'empresa', name: 'Empresa', type: 'link'},

    ]
  },
  {
    state: '',
    name: 'PARÂMETROS',
    type: 'saperator',
    icon: 'security'
  }, 
  {
    state: 'instiUser',
    name: 'Paramêtros',
    type: 'sub',
    icon: 'security',
    children: [ 
          {state: 'parametros', name: 'Parâmetros', type: 'link'},
          // {state: 'parametros-config', name: 'Configurações parâmetros', type: 'link'},

          // {state: 'empresa', name: 'Empresa', type: 'link'},

    ]
  },


  {
    state: '',
    name: 'Configurações',
    type: 'saperator',
    icon: 'av_timer',
    rules:'is_dev',
  }, 
  {
    state: 'gestao-condominio',
    name: 'Configurações',
    type: 'sub',
    icon: 'build',
    rules:'is_dev',
    children: [ 
          {state: 'parametros', name: 'Paramêtros', type: 'link'},
    ]
  },
    // {
    //   state: '',
    //   name: 'MOVIMENTAÇÃO',
    //   type: 'saperator',
    //   icon: 'av_timer'
    // },
    // {
    //   state: 'gestao-condominio',
    //   name: 'Movimentação',
    //   type: 'sub',
    //   icon: 'av_timer',
    // },
]; 
@Injectable()
export class MenuItems {
    private menu_itens: Menu[];
    private filtereds: Menu[];
    private original_values:Menu[];
    private curent_criteria:any;
    private renderized:Menu[];
    private insti_service:InstiService;
    private item_atual:any;
    constructor(){
        //items?:Menu[]
        //this.menu_itens=!items? MENUITEMS: items;
        this.initService()
            .setMenuitem(this.setOriginals(MENUITEMS).getOriginals());
    }
    private initService(){
        this.insti_service =new InstiService();
        return this;
    }
    private setOriginals(value){ 
        this.original_values=value;
        return this;
    }
    private setMenuitem(item){ 
        this.menu_itens=item;
        return this; 
    }
    private setFiltereds(item) { 
        this.filtereds=item;
        return this; 
    }
    private setRender(value){
        this.renderized=value;
        return this;
    }
    getInstiService(){ return this.insti_service;}
    /**
     * ALUISIO FERREIRA DE SOUSA 15/02/2020
     * @Todo por enquando o unico filtro é o para aplicar as regras;
     */
    private filter(){
         let helprs=new InstiHelpers();
        //helprs.findRecursive()
    }  
    
    private prepareRenderize(){
        
        //this.renderized=this.getOriginals();
        
        let l_itens=this.getOriginals();
        /**
         * @TODO ALUISIO FERREIRA DE SOUSA 17/02/2020
         * Verificar qual a ação deve ser adotada quando não tem usuario logado.
         * Por enquanto esta retornando o menu inteiro.
         */
         
        if(!this.getInstiService().getUser().hasData()){
            return this;
        }
        let retorno:Menu[]=[];
        /**
         * childitem
         * subchildren
         */
         l_itens.forEach(function(atual){
            let item=new instiMenuItem(atual);
            if(!item.isValid()){
             return this;   
            }
            retorno.push(atual);
         });
        return this.setRender(retorno);
    }
  getOriginals():Menu[]{ return this.original_values;} 
  getMenuitem(): Menu[] { return this.menu_itens;}
  getFiltereds(): Menu[] { return this.filtereds;}
  renderize():Menu[]{
    return this.prepareRenderize().renderized; 
   // return !this.renderized? this.prepareRenderize().renderized : this.renderized;
  }
  
  remove(param){
      let helprs=new InstiHelpers();
      if(helprs.isString(param)){
          
      }
  }
}
